<template>
  <div class="calendar-widget">
    <div class="calendar-header">
      <div class="calendar-nav">
        <button class="nav-btn" @click="previousMonth">
          <b-icon icon="chevron-left"></b-icon>
        </button>
        <button class="nav-btn" @click="previousMonth">
          <b-icon icon="chevron-double-left"></b-icon>
        </button>
      </div>
      <span class="calendar-month-year">{{ currentMonthYear }}</span>
      <div class="calendar-nav">
        <button class="nav-btn" @click="nextMonth">
          <b-icon icon="chevron-right"></b-icon>
        </button>
        <button class="nav-btn" @click="nextMonth">
          <b-icon icon="chevron-double-right"></b-icon>
        </button>
      </div>
    </div>

    <div class="calendar-grid">
      <div
        v-for="day in $t('calendar.days')"
        :key="day"
        class="calendar-day-header"
      >
        {{ day }}
      </div>

      <div
        v-for="(day, index) in calendarDays"
        :key="index"
        class="calendar-day"
        :class="{
          'other-month': !day.isCurrentMonth,
          'today': day.isToday,
          'selected': day.isSelected,
          'has-events': day.hasEvents
        }"
        @click="selectDate(day)"
      >
        {{ day.dayNumber }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CalendarWidget',

  props: {
    eventDates: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      currentDate: this.$dayjs(),
      selectedDate: null
    }
  },

  computed: {
    currentMonthYear() {
      const monthIndex = this.currentDate.month()
      const year = this.currentDate.year()
      return `${this.$t('calendar.months')[monthIndex]} ${year}`
    },

    calendarDays() {
      // Force Vue to track selectedDate as a dependency
      const selectedDate = this.selectedDate

      const days = []
      const startOfMonth = this.currentDate.startOf('month')
      const endOfMonth = this.currentDate.endOf('month')
      const today = this.$dayjs()

      // Get the day of week for the first day (0 = Sunday, 1 = Monday, etc.)
      // We want Monday as the first day, so we need to adjust
      let startDayOfWeek = startOfMonth.day()
      startDayOfWeek = startDayOfWeek === 0 ? 6 : startDayOfWeek - 1 // Convert to Monday-based

      // Add days from previous month
      for (let i = startDayOfWeek - 1; i >= 0; i--) {
        const date = startOfMonth.subtract(i + 1, 'day')
        days.push(this.createDayObject(date, false, today, selectedDate))
      }

      // Add days from current month
      for (let i = 1; i <= endOfMonth.date(); i++) {
        const date = startOfMonth.date(i)
        days.push(this.createDayObject(date, true, today, selectedDate))
      }

      // Add days from next month to complete the grid (6 rows)
      const remainingDays = 42 - days.length
      for (let i = 1; i <= remainingDays; i++) {
        const date = endOfMonth.add(i, 'day')
        days.push(this.createDayObject(date, false, today, selectedDate))
      }

      return days
    }
  },

  methods: {
    createDayObject(date, isCurrentMonth, today, selectedDate) {
      const dateString = date.format('YYYY-MM-DD')

      return {
        date: date,
        dayNumber: date.date(),
        isCurrentMonth: isCurrentMonth,
        isToday: date.isSame(today, 'day'),
        isSelected: selectedDate && date.isSame(selectedDate, 'day'),
        hasEvents: this.eventDates.includes(dateString)
      }
    },

    previousMonth() {
      this.currentDate = this.currentDate.subtract(1, 'month')
    },

    nextMonth() {
      this.currentDate = this.currentDate.add(1, 'month')
    },

    selectDate(day) {
      if (this.selectedDate && day.date.isSame(this.selectedDate, 'day')) {
        // Deselect if clicking the same date
        this.selectedDate = null
        this.$emit('date-selected', null)
      } else {
        this.selectedDate = day.date
        this.$emit('date-selected', day.date.format('YYYY-MM-DD'))
      }
    }
  }
}
</script>
